<template>
  <div class="storeItem" @click="onClickItem(item)">
    <div>
      <div class="store-icon">
        <i class="ico ico-icon_14"></i>
      </div>
      <div class="storeContent">
        <div class="storeInfo">
          <div class="storeText">
            <div class="storeName">{{item.store_name}}</div>
            <div class="storeDistance">{{item.distance | distance2}} | {{item.store_address}}</div>
          </div>
          <div class="store-button">
            <div>进店</div>
          </div>
        </div>
        <div class="storeImage">
          <div v-for="(unit, rank) in item.imgs" :key="rank">
            <QualityImg :src="unit" width="180" height="180" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import QualityImg from '@/components/qualityImg/qualityImg.vue'
export default {
    name: 'serviceStoreItem',
    data () {
        return {

        }
    },
    components:{
        QualityImg
    },
    props: {
        item: {
            type: Object,
            default () {
                return {}
            }
        }
    },
    methods: {
        onClickItem (item) {
            this.$emit('onClickItem', item)
        }
    }
}
</script>
<style lang="stylus" scoped>
.storeItem
  padding px2vw(20)
  > div
    background #ffffff
    padding px2vw(30) px2vw(20)
    border-radius px2vw(10)
    display flex
  .storeContent
    margin-left px2vw(15)
    .storeInfo
      display flex
      width px2vw(622)
      justify-content space-between
      .storeText
        .storeName
          font-size px2vw(30)
          font-weight bold
          width px2vw(461)
          line-height 1.2
          textOverflow()
        .storeDistance
          font-size px2vw(24)
          color #b0b0b0
          margin px2vw(20) 0
          width px2vw(461)
          textOverflow()
      .store-button
        color #fc2d2d
        font-size px2vw(26)
        flex-shrink 0
        height px2vw(40)
        border 2px solid #fc2d2d
        background #ffdede
        display flex
        align-items center
        padding 0 px2vw(20)
        border-radius px2vw(20)
    .storeImage
      display flex
      > div
        width px2vw(180)
        width px2vw(180)
        margin-right px2vw(13)
</style>
